import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'

//引入moment组件
import moment from 'moment';
import * as echarts from 'echarts';

import 'lib-flexible';

Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
Vue.config.productionTip = false


Vue.prototype.getToken = function () {
    const token = localStorage.getItem("token");
    if (token === "" || token == null) {
        this.$message({
            showClose: true,
            message: "请先登录",
            type: "error",
            duration: "3000"
        })
        this.$router.push({ path: "/Login" })
    }
    return token;
}
Vue.prototype.setToken = function (token) {
    localStorage.setItem("token", token)
}

Vue.prototype.setUserId = function (userId) {
    localStorage.setItem("userId", userId)
}
Vue.prototype.getUserId = function () {
    const userId = localStorage.getItem("userId");
    return userId;
}

Vue.prototype.setUserName = function (userName) {
    localStorage.setItem("userName", userName)
}
Vue.prototype.getUserName = function () {
    const userName = localStorage.getItem("userName")
    return userName;
}

Vue.prototype.setLoginType = function (loginType) {
    localStorage.setItem("loginType", loginType)
}
Vue.prototype.getLoginType = function () {
    const loginType = localStorage.getItem("loginType")
    return loginType;
}

Vue.prototype.setCompanyId = function (companyId) {
    localStorage.setItem("companyId", companyId)
}
Vue.prototype.getCompanyId = function () {
    const companyId = localStorage.getItem("companyId")
    return companyId
}

Vue.prototype.setPersonalCenter = function (isShow) {
    localStorage.setItem("isShow", isShow)
}
Vue.prototype.getPersonalCenter = function () {
    const isShow = localStorage.getItem("isShow")
    return isShow
}

Vue.prototype.setDefaultPath = function (path) {
    localStorage.setItem("path", path)
}
Vue.prototype.getDefaultPath = function () {
    let path = localStorage.getItem("path")
    if (path == null) {
        path = '/hello'
    }
    return path
}

Vue.prototype.setCurrentSystem = function (sys) {
    localStorage.setItem("sys", sys)
}
Vue.prototype.getCurrentSystem = function () {
    let sys = localStorage.getItem("sys")
    if (sys == null) {
        sys = 0
    }
    return sys
}

Vue.prototype.getImagePath = function () {
    return 'image.ctshake.cn/'
}

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    } else {
        document.title = '乌鸦背调'
    }
    next()
})

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')